import {BVDMatchDTO} from "@modules/onBoarding/infrastructure/dto/BVDMatchDTO";

export class BVDCompanyDTO {


    private readonly _bvdId: string;
    private readonly _europeanVatNumber: string;
    private readonly _bvdMatchDTO: BVDMatchDTO;

    constructor(bvdId: string, europeanVatNumber: string, bvdMatchDTO: BVDMatchDTO) {
        this._bvdId = bvdId;
        this._europeanVatNumber = europeanVatNumber;
        this._bvdMatchDTO = bvdMatchDTO;
    }

    get bvdId(): string {
        return this._bvdId;
    }

    get europeanVatNumber(): string {
        return this._europeanVatNumber;
    }

    get bvdMatchDTO(): BVDMatchDTO {
        return this._bvdMatchDTO;
    }

}
